var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiSettingsDataPrivacy24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.316,3.098l-.651-.022c-1.583-.055-5.528-.406-8.003-2.476l-.405-.338c-.219-.182-.536-.182-.754,0l-.405,.338C8.62,2.67,4.676,3.021,3.096,3.076l-.652,.022c-.317,.011-.568,.271-.568,.588v5.536c0,1.016,.268,10.045,9.488,14.265l.01,.008,.258,.118c.077,.035,.161,.053,.244,.053h0l.002-.002h.002v.002c.082,0,.167-.018,.244-.053l.258-.118c.535-.245,1.058-.514,1.554-.8l-.003-.006c7.707-4.463,7.948-12.511,7.948-13.467l.006-5.536c0-.318-.251-.578-.568-.588Zm-.614,6.125c0,.939-.247,9.292-8.815,13.202l-.009,.005-.009-.005C3.299,18.515,3.052,10.162,3.052,9.223V4.255l.084-.002c1.703-.059,5.96-.445,8.719-2.746l.027-.024,.027,.022c2.754,2.303,7.012,2.689,8.716,2.748l.082,.002-.006,4.967Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38,8.02v-1.618c0-1.487-1.21-2.698-2.698-2.698s-2.698,1.21-2.698,2.698v1.618h-2.157v6.15c0,.773,.628,1.403,1.403,1.403h6.905c.773,0,1.403-.628,1.403-1.403v-6.15h-2.159Zm-4.316-1.618c0-.892,.726-1.618,1.618-1.618s1.618,.726,1.618,1.618v1.618h-3.237v-1.618Zm5.395,7.767h-.001c0,.18-.146,.325-.324,.325h-6.904c-.178,0-.324-.145-.324-.324v-5.072h7.552v5.07Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.142,12.17h.001v1.244h1.079v-1.245c.317-.188,.539-.519,.539-.912,0-.594-.484-1.079-1.079-1.079s-1.079,.485-1.079,1.079c0,.394,.224,.725,.539,.913Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSettingsDataPrivacy24);
export default __webpack_public_path__ + "static/media/uiSettingsDataPrivacy24.09d3a27ffdae61eff20aa6435fe3901b.svg";
export { ForwardRef as ReactComponent };